/**
 * Feature-флаги интерфейса. Неимплементированные разделы скрыты по умолчанию и включаются
 * env-переменной (REACT_APP_FEATURE_*) при готовности — без правки кода меню.
 *
 * CRA инлайнит process.env.REACT_APP_* на этапе сборки; для дев-сервера значения берутся
 * из frontend/.env. Значение по умолчанию (false) работает без какой-либо настройки.
 */
export type FeatureKey = 'planning';

function envBool(name: string, def: boolean): boolean {
    const v = process.env[name];
    if (v === undefined || v === '') {
        return def;
    }
    const s = v.toLowerCase();
    return s === 'true' || s === '1' || s === 'on';
}

export const FEATURES: Record<FeatureKey, boolean> = {
    // Список покупок открыт по умолчанию с MR-3 purchase-loop-closure (замкнутый цикл покупки).
    planning: envBool('REACT_APP_FEATURE_PLANNING', true),
};

export const isFeatureEnabled = (key: FeatureKey): boolean => FEATURES[key];
